import { useContext } from "react";

import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";
import { AppContext } from "@1js/acui-context";

export const useGetId = (
  id: string,
  isPreviewGalleryButton: boolean | undefined
): string => {
  const context = useContext(AppContext);

  if (!isPreviewGalleryButton) {
    return id;
  }

  const uniquePreviewIdEnabled = checkExperiment(
    context,
    ribbonExperiments.appGalleryPreviewButtonIdIsEnabled
  );

  return uniquePreviewIdEnabled ? `${id}-PreviewButton` : id;
};
